module.exports = __webpack_public_path__ + "4758a6ad6b2152b2b49fc96229db5c29.jpg";